"use client";

import { useActionState } from "react";
import Link from "next/link";
import { signupAction } from "../actions";
import { Button } from "@/components/ui/button";
import { FormField, Input } from "@/components/ui/input";

export function SignupForm() {
  const [state, formAction, pending] = useActionState(signupAction, undefined);

  return (
    <form action={formAction} className="space-y-4">
      <FormField label="Company name" htmlFor="organizationName">
        <Input id="organizationName" name="organizationName" required placeholder="Acme Manufacturing Ltd" />
      </FormField>
      <FormField label="Your name" htmlFor="name">
        <Input id="name" name="name" required placeholder="Jordan Smith" />
      </FormField>
      <FormField label="Work email" htmlFor="email">
        <Input id="email" name="email" type="email" autoComplete="email" required placeholder="you@company.com" />
      </FormField>
      <FormField label="Password" htmlFor="password">
        <Input
          id="password"
          name="password"
          type="password"
          autoComplete="new-password"
          minLength={8}
          required
        />
      </FormField>
      {state?.error ? (
        <p className="text-sm text-status-danger" role="alert">
          {state.error}
        </p>
      ) : null}
      <Button type="submit" className="w-full" disabled={pending}>
        {pending ? "Creating your workspace…" : "Start free trial"}
      </Button>
      <p className="text-center text-xs text-slate-500">
        14-day free trial, no card required. By continuing you agree this is a demo
        environment.
      </p>
      <p className="text-center text-sm text-slate-500">
        Already have an account?{" "}
        <Link href="/login" className="font-medium text-brand-orange hover:underline">
          Sign in
        </Link>
      </p>
    </form>
  );
}
